import { createRoot, hydrateRoot } from 'react-dom/client';
import { AppShell } from './AppShell';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

declare global {
    interface Window {
        __SERVER_STATE__?: unknown;
        __CONFIG__?: AlgoliaConfig;
        __REFINEMENTS__?: AlgoliaRefinements;
        __algoliaMounted__?: boolean;
    }
}

const host = document.getElementById('algolia-instantsearch') as HTMLElement | null;

if (!host) {
    // Element not present on this page, silently skip
} else if (window.__algoliaMounted__) {
    // Already mounted, skip
} else {
    window.__algoliaMounted__ = true;

    const hasSSR = host.hasChildNodes();

    if (hasSSR) {
        const appWithSSR = (
            <div suppressHydrationWarning={true}>
                <AppShell
                    domElement={host}
                    serverState={window.__SERVER_STATE__}
                    config={window.__CONFIG__}
                    refinements={window.__REFINEMENTS__}
                />
            </div>
        );
        hydrateRoot(host, appWithSSR, {
            onRecoverableError: () => {
                // Silently suppress hydration warnings
            }
        });
        queueMicrotask(() => {
            (window as any).__APP_HYDRATED__ = true;
            window.dispatchEvent(new Event('app:hydrated'));
        });
    } else {
        const appWithoutSSR = (
            <div>
                <AppShell
                    domElement={host}
                    config={window.__CONFIG__}
                    refinements={window.__REFINEMENTS__}
                />
            </div>
        );
        createRoot(host).render(appWithoutSSR);
    }

    try { delete window.__SERVER_STATE__; } catch (e) { /* ignore */ }
}